/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userloginname2Inputs */

const en_entity_userloginname2 = /** @type {(inputs: Entity_Userloginname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Login Name`)
};

const de_entity_userloginname2 = /** @type {(inputs: Entity_Userloginname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldename`)
};

/**
* | output |
* | --- |
* | "User Login Name" |
*
* @param {Entity_Userloginname2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userloginname2 = /** @type {((inputs?: Entity_Userloginname2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userloginname2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userloginname2(inputs)
	return de_entity_userloginname2(inputs)
});
export { entity_userloginname2 as "entity_userLoginName" }